import React from "react";
import { Container } from "@mui/material";
import UserRoleManager from "../UserRoleManager";

export default function UserManagementSection() {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <UserRoleManager />
    </Container>
  );
}
